import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Settings from '@mui/icons-material/Settings';
import OfferPaymentPlanParamsComponent from './OfferPaymentPlanParamsComponent';
import { CollapseCard } from '@totalsoft/rocket-ui';

export const OfferPaymentPlanParamsCard = ({
  t,
  scheduleCellParamHeader,
  scheduleTypeCellParamTemplates,
  selectedScheduleTypeCellParamTemplate,
  handleScheduleTypeCellParamTemplateChange,
  scheduleCellParamColumns,
  scheduleCellParamValues,
  handleHeaderPropertyChange,
  handleRowPropertyChange,
  handlePropertyParamChange,
  handleRowsPropertyChange,
  onSave,
  onApply,
  onReset,
  onExpand,
  cardExpanded,
  saving,
  isDirty,
  isTemplateChanged,
  isContractModification,
  handleMonthClick,
  handleYearClick,
  handleAllMonthsSelection,
  selectedOptions,
  setSelectedOptions,
  onResetSelectedCells,
  isCalendarView,
  handleCalendarViewChange
}) => {
  return (
    <CollapseCard
      id={'offerPaymentPlanParamsCard'}
      icon={Settings}
      title={t('OfferEdit.PaymentPlan.SeasonalSettings')}
      expanded={cardExpanded}
      onToggle={onExpand}
      toggleOnHeaderClick
    >
      <OfferPaymentPlanParamsComponent
        scheduleCellParamHeader={scheduleCellParamHeader}
        scheduleCellParamColumns={scheduleCellParamColumns}
        scheduleTypeCellParamTemplates={scheduleTypeCellParamTemplates}
        handleScheduleTypeCellParamTemplateChange={handleScheduleTypeCellParamTemplateChange}
        selectedScheduleTypeCellParamTemplate={selectedScheduleTypeCellParamTemplate}
        scheduleCellParamValues={scheduleCellParamValues}
        handleHeaderPropertyChange={handleHeaderPropertyChange}
        handleRowPropertyChange={handleRowPropertyChange}
        handlePropertyParamChange={handlePropertyParamChange}
        handleRowsPropertyChange={handleRowsPropertyChange}
        onSave={onSave}
        onApply={onApply}
        onReset={onReset}
        saving={saving}
        isDirty={isDirty}
        isTemplateChanged={isTemplateChanged}
        isContractModification={isContractModification}
        handleMonthClick={handleMonthClick}
        handleYearClick={handleYearClick}
        handleAllMonthsSelection={handleAllMonthsSelection}
        selectedOptions={selectedOptions}
        setSelectedOptions={setSelectedOptions}
        onResetSelectedCells={onResetSelectedCells}
        isCalendarView={isCalendarView}
        handleCalendarViewChange={handleCalendarViewChange}
      />
    </CollapseCard>
  );
};

OfferPaymentPlanParamsCard.propTypes = {
  t: PropTypes.func.isRequired,
  scheduleCellParamHeader: PropTypes.object.isRequired,
  scheduleCellParamColumns: PropTypes.array,
  scheduleCellParamValues: PropTypes.array,
  handleHeaderPropertyChange: PropTypes.func.isRequired,
  handleRowPropertyChange: PropTypes.func.isRequired,
  handlePropertyParamChange: PropTypes.func.isRequired,
  handleRowsPropertyChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onExpand: PropTypes.func.isRequired,
  cardExpanded: PropTypes.bool,
  saving: PropTypes.bool.isRequired,
  isDirty: PropTypes.bool.isRequired,
  isTemplateChanged: PropTypes.bool.isRequired,
  scheduleTypeCellParamTemplates: PropTypes.array,
  selectedScheduleTypeCellParamTemplate: PropTypes.object,
  handleScheduleTypeCellParamTemplateChange: PropTypes.func.isRequired,
  isContractModification: PropTypes.bool.isRequired,
  handleMonthClick: PropTypes.func.isRequired,
  handleYearClick: PropTypes.func.isRequired,
  handleAllMonthsSelection: PropTypes.func.isRequired,
  selectedOptions: PropTypes.array.isRequired,
  setSelectedOptions: PropTypes.func.isRequired,
  onResetSelectedCells: PropTypes.func.isRequired,
  isCalendarView: PropTypes.bool.isRequired,
  handleCalendarViewChange: PropTypes.func.isRequired
};

export default withTranslation()(OfferPaymentPlanParamsCard);
